/**
 * Fetch city and state from pincode using Indian Postal API
 */
export const fetchLocationFromPincode = async (pincode: string): Promise<{
  city: string;
  state: string;
  country: string;
} | null> => {
  try {
    const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await response.json();

    if (data && data[0]?.Status === 'Success' && data[0]?.PostOffice?.length > 0) {
      const postOffice = data[0].PostOffice[0];
      return {
        city: postOffice.District || postOffice.Block || '',
        state: postOffice.State || '',
        country: postOffice.Country || 'India'
      };
    }
    return null;
  } catch (error) {
    console.error('Pincode lookup error:', error);
    return null;
  }
};

/**
 * Validate Indian pincode format
 */
export const isValidPincode = (pincode: string): boolean => {
  return /^[1-9][0-9]{5}$/.test(pincode);
};
